<template>
  <div class="row">
    <div class="col-md-2"></div>
    <div class="col-md-8">
      <div class="card card-body mb-3">
        <h2>
          {{ article.title }}<br/>
        </h2>

        <img
          :src="article.image"
          class="img-lg"
          @load="isLoaded = true"
          v-show="isLoaded"
          alt="image"
        />

        <hr/>

        <small>
          <i class="far fa-calendar-alt text-light"></i>
          {{ toLocalPrettyDateTime(article.created_at) }}
        </small>

        <p class="text-bold">
          {{ article.summary }}
        </p>

        <p v-html="article.body"></p>
      </div>
    </div>
    <div class="col-md-2"></div>
  </div>
</template>

<script>
import { toLocalPrettyDateTime } from '@/common/utils/formatting';
import { setBreadcrumbs } from '@/common/utils/breadcrumbs';
import { GenericDetailMixin } from '@/common/utils/mixins';

export default {
  name: 'ArticleDetail',
  data() {
    return {
      slug: this.$route.params.slug,
      objectName: 'article',
      article: {},
      isLoaded: false,
    };
  },
  methods: {
    toLocalPrettyDateTime,
    getApiPath() {
      return `/public/articles/${this.$route.params.slug}`;
    },
    postProcess() {
      setBreadcrumbs('articleDetail', [this.article.title]);
    },
  },
  mixins: [
    GenericDetailMixin,
  ],
};
</script>

<style>
.img-lg {
  width: 100%;
  height: auto;
}
</style>
